<template>
  <div
    :class="[
      $style.actionSidebarSettingsTriggersItem,
      {
        [$style.actionSidebarSettingsTriggersItemColumn]: type === types[3],
      }
    ]"
  >
    <header :class="$style.actionSidebarSettingsTriggersItemHeader">
      <PWSwitcher v-model="enabledLocal" />
      <div>
        <slot>
          {{ title }}
        </slot>
      </div>
    </header>
    <div v-if="enabledLocal">
      <div
        v-if="type === types[0]"
        :class="$style.actionSidebarSettingsTriggersItemTypeTimeout"
      >
        <input
          :value="valueLocal"
          type="number"
          :class="$style.actionSidebarSettingsTriggersInput"
          @blur="handleNumberBlur($event, 0, 300)"
        >
        <span :class="$style.actionSidebarSettingsTriggersInputLabel">{{ $t('secondShort') }}</span>
      </div>

      <div
        v-if="type === types[1]"
        :class="$style.actionSidebarSettingsTriggersItemTypeScroll"
      >
        <input
          :value="valueLocal"
          type="number"
          :class="$style.actionSidebarSettingsTriggersInput"
          @blur="handleNumberBlur($event, 0, 100)"
        >
        <span :class="$style.actionSidebarSettingsTriggersInputLabel">%</span>
      </div>

      <div
        v-if="type === types[2]"
        :class="$style.actionSidebarSettingsTriggersItemTypeDevice"
      >
        <div :class="$style.actionSidebarSettingsTriggersItemTypeDeviceCtx">
          <PWDeviceToggle
            v-model="valueLocal"
            size="small"
          />
        </div>
      </div>

      <div
        v-if="type === types[3]"
        :class="$style.actionSidebarSettingsTriggersItemTypeUrl"
      >
        <PWChipParent v-model="valueLocal" />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * UI
 */
import PWSwitcher from '@/components/_ui/PWSwitcher.vue'
import PWDeviceToggle from '@/components/_ui/Pickers/PWDeviceToggle.vue'
import PWChipParent from '@/components/_ui/Chips/PWChipParent.vue'

const TYPES = [
  'timeout',
  'scroll',
  'device',
  'url'
]

export default {
  components: {
    PWSwitcher,
    PWDeviceToggle,
    PWChipParent
  },
  props: {
    type: {
      type: String,
      required: true,
      validator: t => TYPES.includes(t)
    },
    title: {
      type: String,
      default: null
    },
    enabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String, Array],
      default: null
    }
  },
  data: () => ({
    types: TYPES
  }),
  computed: {
    enabledLocal: {
      get () { return this.enabled },
      set (val) { this.$emit('update-enabled', val) }
    },
    valueLocal: {
      get () { return this.value },
      set (val) { this.$emit('update-value', val) }
    }
  },
  methods: {
    handleNumberBlur (ev, min, max) {
      if (!ev.target.value) {
        this.valueLocal = min
      } else {
        const val = ev.target.valueAsNumber
        this.valueLocal = val > max
          ? max
          : val < min
            ? min
            : val
      }
    }
  }
}
</script>

<style module lang="scss">
@use '@/assets/scss/mixins';

.actionSidebarSettingsTriggersItem {
  display: flex;
  border-radius: 8px;
  background-color: var(--grey-100);
  padding: 16px 12px;
  gap: 12px;

  &:not(.actionSidebarSettingsTriggersItemColumn) {
    align-items: center;
    justify-content: space-between;
  }

  &.actionSidebarSettingsTriggersItemColumn {
    flex-direction: column;
  }
}

.actionSidebarSettingsTriggersItemHeader {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: var(--primary);
  cursor: pointer;
  user-select: none;

  @include mixins.body2;
}

.actionSidebarSettingsTriggersInputLabel {
  color: var(--main-blue);
  user-select: none;
  cursor: default;

  @include mixins.body2;
}

.actionSidebarSettingsTriggersInput {
  all: unset;
  display: inline-flex;
  text-align: right;
  padding: 0 4px;
  background-color: transparent;
  cursor: text;
  color: var(--main-blue);
  width: 28px;
  border-radius: 4px;
  transition: background-color 0.3s;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type=number] {
    -moz-appearance: textfield;
  }

  &:hover,
  &:focus,
  &:focus-visible {
    background-color: var(--grey-300);
  }

  @include mixins.body2;
}

.actionSidebarSettingsTriggersItemTypeTimeout,
.actionSidebarSettingsTriggersItemTypeScroll {
  display: inline-flex;
  align-items: center;
}

.actionSidebarSettingsTriggersItemTypeDevice {
  position: relative;
  height: 24px;
}

.actionSidebarSettingsTriggersItemTypeDeviceCtx {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}
</style>
